exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-dropzone[data-v-f1e926b4]{min-height:126px}.dz-add-files[data-v-f1e926b4]{padding-top:30px}.dz-uploaded-file[data-v-f1e926b4]{cursor:default}.dz-uploaded-file .dz-filename[data-v-f1e926b4]{width:100%;height:43px}.asset-preview .thumbnail[data-v-f1e926b4]{border-top-left-radius:unset;border-top-right-radius:unset;height:126px}.asset-preview .thumbnail img[data-v-f1e926b4]{max-height:124px}", ""]);

// exports
